import { ActionType } from '@editor/src/js/constants/common-action-type';
import { IMenuEventParams } from '@src/slide/application/service/menu-manager/menu-event/menu-event.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { IAddonHandler } from '@src/slide/application/service/addon/addon-handler.interface';
import { IEmptyModel } from '@src/slide/domain/ui-model/element-modeles/Interface/empty-model.interface';
import { ADDON_PREFIX } from '@src/slide/domain/ui-model/element-modeles/property/addon/addon.interface';
import { TDWVer9Type } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ILayoutDataModel } from '@tencent/slide-sdk-model';
import _get from 'lodash/get';

/**
 * 事件响应匹配
 * 返回boolean值，表示此事件是否已在model独有事件匹配上，匹配上返回TRUE，结束匹配，未匹配上返回FALSE，外层继续匹配通用事件
 * @param model 当前uiModel
 * @param menuEventParams 菜单传参
 */
export function handleMenuEvent(model: IEmptyModel, menuEventParams: IMenuEventParams): boolean {
    const { actionType, values } = menuEventParams;
    if (actionType.startsWith(ADDON_PREFIX)) {
        // 范围匹配事件（插件）
        (getAppServices().viewableServiceLayer.addonManager.addonHandler as IAddonHandler)
            .handleAddonSceneItemClick(actionType, { ver9: TDWVer9Type.DETAIL_TXT_RIGHT_CLK });
        return true;
    }
    if (actionType === ActionType.SHOW_MASTER_SHAPE) {
        (getAppServices().viewableServiceLayer.selectionService
            .currentSlide?.sdkData as unknown as ILayoutDataModel)?.api?.updateShowMasterSp(!!_get(values, 'showMasterSp'));
        return true;
    }
    return false;
}

function getAppServices(): IEditorAppServices {
    return AppServiceProvider.getInstance()
        .getAppServices() as IEditorAppServices;
}
